<h2 *ngIf="noticeHeadline">{{ noticeHeadline }}</h2>
